import { planningAPI } from "../../axios";

export const actions = {

    // PreOpcr
    GetSinglePreOpcr(context, data){
        return planningAPI.get(`PreOpcr/${data}`);
    },
    ImportAPI(context, data){
        return planningAPI.post(`PreOpcr/Import/PlanningApi/${data}`);
    },
    AddPreOpcr(context, data){
        return planningAPI.post(`PreOpcr/Add`, data);
    },
    UpdatePreOpcr(context, data){
        return planningAPI.put(`PreOpcr/Update/${data.id}`, data);
    },
    PostPreOpcr(context, data){
        return planningAPI.post(`PreOpcr/Post/${data}`);
    },
    ReturnPlanningPreOpcr(context, data){
        return planningAPI.post(`PreOpcr/Planning/Return/${data.id}/${data.remarks}`);
    },
    ReturnFinancePreOpcr(context, data){
        return planningAPI.post(`PreOpcr/Finance/Return/${data.id}/${data.remarks}`);
    },
    DeletePreOpcr(context, data){
        return planningAPI.delete(`PreOpcr/Remove/${data}`);
    },
    GetAllPreOpcr(context, data){
        return planningAPI.get(`PreOpcr/All/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPostedPreOpcr(context, data){
        return planningAPI.get(`PreOpcr/Posted/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetCampusPreOpcr(context, data){
        return planningAPI.get(`PreOpcr/Campus/${data.campusId}/${data.cycle}`);
    },
    AddPreOpcrItems(context, data){
        return planningAPI.post(`PreOpcr/Items/Add`, data);
    },
    GetPostedPlanningOPCR(context, data){
        return planningAPI.get(`PreOpcr/Planning/Pending/${data.campusId}/${data.cycle}`);
    },
    GetApprovedPlanningOPCR(context, data){
        return planningAPI.get(`PreOpcr/Planning/Approved/${data.campusId}/${data.cycle}`);
    },
    GetPostedFinanceOPCR(context, data){
        return planningAPI.get(`PreOpcr/Finance/Pending/${data.campusId}/${data.cycle}`);
    },
    GetApprovedFinanceOPCR(context, data){
        return planningAPI.get(`PreOpcr/Finance/Approved/${data.campusId}/${data.cycle}`);
    },
    ApprovePlanningOPCR(context, data){
        return planningAPI.post(`PreOpcr/Planning/Approve/${data}`);
    },
    ApproveFinanceOPCR(context, data){
        return planningAPI.post(`PreOpcr/Finance/Approve/${data}`);
    },
    GetPendingByFinanceAndPlanning(context, data){
        return planningAPI.get(`PreOpcr/Pending/${data.campusId}/${data.cycle}`);
    },
    GetApproveByFinanceAndPlanning(context, data){
        return planningAPI.get(`PreOpcr/PlanningAndFinance/Approved/${data.campusId}/${data.cycle}`);
    },
    ApproveOPCR(context, data){
        return planningAPI.post(`PreOpcr/Approve/${data}`);
    },
    ReturnOPCR(context, data){
        return planningAPI.post(`PreOpcr/Return/${data.id}`, {
            body: data.remarks
        });
    },
    GetOPCRLogs(context, data){
        return planningAPI.get(`PreOpcr/Log/${data}`);
    },
    ImportOPCR(context, data){
        return planningAPI.post(`PreOpcr/Import/${data}`);
    },
    GetProposalPreOpcr(context, data){
        return planningAPI.get(`PreOpcr/Proposal/${data.proposalId}/${data.deliveryUnitId}`);
    }
}